import { Form, Input, Modal } from 'antd'
import { useForm } from 'antd/lib/form/Form'
import { useAddBudgetMutation } from 'features/leads'
import { useLeadDetails } from 'features/leads/providers/LeadDetailsProvider'
import { TAddBudget } from 'features/leads/routes/details/profile/Boxes/BudgetBlock'
import React, { FC, useEffect } from 'react'

const AddBudgetModal: FC<{
 visible?: boolean
 onCancel?: () => void
 budget?: any
 id?: any
}> = ({ visible, onCancel, budget, id }) => {
 const [addBudget, { isLoading }] = useAddBudgetMutation()

 const { leadId } = useLeadDetails()

 const [form] = useForm<TAddBudget>()

 const handleAddBudget = async () => {
  const values = await form.validateFields()
  // budget_id is only sent while editing — the API adds a new row without it
  if (budget) {
   await addBudget({ ...values, budget_id: id, lead_id: leadId }).unwrap()
  } else {
   await addBudget({ ...values, lead_id: leadId }).unwrap()
  }
  form.resetFields()
  onCancel?.()
 }

 useEffect(() => {
  if (budget) {
   form.setFieldsValue({
    budget,
   })
  }
 }, [budget])

 return (
  <Modal
   visible={visible}
   onCancel={onCancel}
   title={`${budget ? 'Edit' : 'Add'} Budget`}
   onOk={handleAddBudget}
   confirmLoading={isLoading}
  >
   <Form form={form}>
    <Form.Item
     name="budget"
     rules={[{ required: true, message: 'Please enter the budget' }]}
    >
     <Input placeholder="Enter budget" maxLength={50} />
    </Form.Item>
   </Form>
  </Modal>
 )
}

export default AddBudgetModal
